<template>

    <div class="v-application v-application--is-ltr theme--light">

        <v-card elevation="24">

            <v-card-title class="text-h6">
                {{ title || 'Confirm Action' }}
            </v-card-title>

            <v-card-text>
                {{ message || 'Are you sure that you would like to perform this action?' }}
            </v-card-text>

            <v-card-text style="color: black; padding-top: 0px;">
                {{ disclaimer || 'By selecting Confirm, you are authorizing this action to be taken' }}
            </v-card-text>

            <v-card-actions>
                <v-btn color="primary" @click="confirm">
                    {{ confirmText || 'Confirm' }}
                </v-btn>
                <v-btn color="red" text @click="close">
                    {{ cancelText || 'Cancel' }}
                </v-btn>
            </v-card-actions>

        </v-card>

    </div>

</template>

<script>
export default {
    props: ["title", "message", "disclaimer", "cancelText", "confirmText", "onConfirm"],
    methods: {

        close() {
            this.$emit('close');
        },

        async confirm() {
            if (!this.onConfirm) {
                this.close();
                return;
            }
            await this.onConfirm();
            this.close();
        }

    }

};
</script>

<style scoped>
.vuetify-modal-wrapper {
    background: transparent;
}
</style>